
import _ from 'underscore';

let CONFIG = {
    debug: false,
    live: true,
    owner: "Sfey Pay OÜ Authserver",
    copyright: 'Copyright Sfey Pay OÜ © 2024',
    /**
     * Application code as registered in authServer
     */
    applicationCode: "AUTH",
    /**
     * OAuth2 redirect URL for UI
     */
    redirectUrl: "/login",

    /**
     * UI base URL
     */
    baseUrl: '/',
    /**
     * UI main page URL (including base URL)
     */
    mainUrl: '/ui',
    /**
     * REST API base URL
     */
    apiUrl: '/rest/auth',

    /**
     * REST API base URL for rights
     */
    apiRightUrl: '/rest',

    profileUrl: '/ui/person/%s',

    /**
     * Default UI language
     */
    defaultLocale: 'et',
    /**
     * Notification message dismiss timeout (s)
     * Specifies how long message is displayed in box at upper right corner
     */
    notificationMessageDismissTimeout: 5,
    /**
     * Notification message time to live (s)
     * Specifies how long message is kept in notification list window
     */
    notificationMessageTtl: 30*60,
    /**
     * Request timeout for REST API (ms)
     */
    restApiTimeout: 600 * 1000,
    /**
     * Supported list page sizes in resource list page.
     * Value "" means "all".
     */
    listPageSizes: ["20", "50", "100", "0"],
    /**
     * Record count in one page
     */
    pageSize: 50,
    /**
     * Use "Range" headers for specifying record count and sorting.
     */
    useRangeHeader: false
};

let CONFIG_LIVE = {
    live: true
};

let CONFIG_TEST = {
    owner: "Degeetia Authserver",
    copyright: 'Copyright Degeetia OÜ © 2019',
    live: false
};

let CONFIG_DEV = {
    owner: "Degeetia Authserver - DEV",
    copyright: 'Copyright Degeetia OÜ © 2019',
    life: false,
    debug: true
};

switch (process.env.REACT_APP_ENV) {
    case "live":
    default:
        CONFIG = _.extend(CONFIG, CONFIG_LIVE);
        break;
    case "test":
        CONFIG = _.extend(CONFIG, CONFIG_TEST);
        break;
    case "dev":
        CONFIG = _.extend(CONFIG, CONFIG_DEV);
        break;
}

export default CONFIG;
